// extracted by mini-css-extract-plugin
module.exports = {"bar":"cart_bar__JRUSk","cartBadge":"cart_cartBadge__13yFB"};